import {env} from './env.ts';

/** Local backend (docker-compose / vite dev / CI). */
export const LOCAL_BACKEND_API_BASE_PATH = 'http://localhost:5001/api/v1/';

function normalizeBasePath(raw: string): string {
    const trimmed = raw.trim();
    return trimmed.endsWith('/') ? trimmed : `${trimmed}/`;
}

/**
 * Base URL for the PocketCFO backend API (must include the `/api/v1/` path segment).
 *
 * - Dev / Vitest: localhost when `VITE_BACKEND_API_URI` is unset.
 * - Production bundles: must be set at build time (Cloud Build `--build-arg`).
 */
export function getBackendApiBasePath(): string {
    const raw = env.backendApiUri?.trim() ?? '';
    if (raw) {
        return normalizeBasePath(raw);
    }
    if (env.isViteDev || env.mode === 'test') {
        return LOCAL_BACKEND_API_BASE_PATH;
    }
    throw new Error(
        'VITE_BACKEND_API_URI is not set. Production builds must pass it via Cloud Build --build-arg.',
    );
}
